import { type MessageDescriptor } from 'react-intl'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchResultTabsStyled } from './styles/GlobalSearchResultTabsStyled'
import { GlobalSearchResultTabStyled } from './styles/GlobalSearchResultTabStyled'
import { useGlobalSearchResultTabsArrowNavigation } from './useGlobalSearchResultTabsArrowNavigation'
import { GlobalSearchResultTypes } from '../../../../value-objects/enums'
import {
  GlobalSearchTabTypes,
  type GlobalSearchTab,
  type GlobalSearchTabTypeEnum,
} from '../../enums/GlobalSearchTabTypeEnum'

export interface IGlobalSearchResultTabsProps {
  tabs: GlobalSearchTab[]
  selectedTab: GlobalSearchTabTypeEnum
  onTabChange: (type: GlobalSearchTabTypeEnum) => void
}

const TAB_MESSAGES: Record<GlobalSearchTabTypeEnum, MessageDescriptor> = {
  [GlobalSearchTabTypes.ALL]: messages.allTab,
  [GlobalSearchResultTypes.ORDER_REQUEST]: messages.orderRequestTab,
  [GlobalSearchResultTypes.EXPENSE_REQUEST]: messages.expenseRequestTab,
  [GlobalSearchResultTypes.TRAVEL_REQUEST]: messages.travelRequestTab,
  [GlobalSearchResultTypes.PURCHASE_ORDER]: messages.purchaseOrderTab,
  [GlobalSearchResultTypes.BILL]: messages.billTab,
  [GlobalSearchResultTypes.PAYMENT]: messages.paymentTab,
  [GlobalSearchResultTypes.CATALOG_ITEM]: messages.catalogItemTab,
  [GlobalSearchResultTypes.VENDOR]: messages.vendorTab,
  [GlobalSearchResultTypes.CONTRACT]: messages.contractTab,
}

export const GlobalSearchResultTabs = ({
  tabs,
  selectedTab,
  onTabChange,
}: IGlobalSearchResultTabsProps) => {
  const intl = useProcurifyIntl()
  const handleTabKeyDown = useGlobalSearchResultTabsArrowNavigation(
    tabs,
    onTabChange
  )

  return (
    <GlobalSearchResultTabsStyled
      role='radiogroup'
      aria-label={intl.formatMessage(messages.filterGroupLabel)}
      onKeyDown={handleTabKeyDown}
    >
      {tabs.map((tab) => {
        const isSelected = tab.type === selectedTab

        return (
          <GlobalSearchResultTabStyled
            key={tab.type}
            role='radio'
            tabIndex={isSelected ? 0 : -1}
            isSelected={isSelected}
            aria-checked={isSelected}
            onClick={() => onTabChange(tab.type)}
          >
            {intl.formatMessage(TAB_MESSAGES[tab.type], { count: tab.count })}
          </GlobalSearchResultTabStyled>
        )
      })}
    </GlobalSearchResultTabsStyled>
  )
}
